const nl = {
  irma: {
    documents: "Documenten",
    noDocumentsAvailable:
      "Geen documenten beschikbaar. Upload documenten om AI-antwoorden te verbeteren.",
    uploadDocument: "Document Uploaden",
    loadingDocuments: "Documenten laden...",
    documentInfo: "Document Informatie",
    untitledDocument: "Document zonder titel",
    aiAssistant: "AI Assistent",
    you: "Jij",
    typeYourMessage: "Type je bericht hier...",
    send: "Versturen",
    suggestedPrompts: "Voorgestelde prompts",
    context: "Context",
    documentSources: "Brondocumenten",
    noDocumentSourcesData: "Geen brondocument gegevens beschikbaar",
    noContextAvailable:
      "Geen context beschikbaar. Stel een vraag om te zien welke documenten de AI gebruikt.",
    keyRisksPrompt: "Wat zijn de belangrijkste risico's in mijn document?",
    summarizePrompt:
      "Vat de belangrijkste punten samen van de geüploade content",
    generateRiskReportPrompt:
      "Genereer een risicobeoordeling op basis van dit document",
    identifyCompliancePrompt:
      "Identificeer potentiële compliance-problemen in dit materiaal",
    largeFileNote:
      "Grote bestanden worden op de achtergrond verwerkt en kunnen tijd kosten.",
    largeFileWarning:
      "Groot bestand gedetecteerd ({size} MB). Verwerking start wanneer je een bericht verzendt en kan enige tijd duren.",
    ctrlEnterHint: "Ctrl ↵",
    enterHint: "Enter ↵",
    confirmDelete: "Bevestig verwijderen",
    confirmDeleteDocument: "Weet je zeker dat je het document wilt verwijderen",
    delete: "Verwijderen",
    cancel: "Annuleren",
    deleteCancelled: "Verwijderen geannuleerd",
    documentDeleted: "Document verwijderd",
    failedToDeleteDocument: "Verwijderen van document is mislukt",
    securityRedirect:
      "Ik kan alleen vragen over risicomanagement beantwoorden. Hoe kan ik je helpen met een risico-gerelateerd onderwerp?",
    outOfScopeRedirect:
      "Ik ben Irma, een gespecialiseerde assistent voor risicomanagement. Kan je je vraag toespitsen op een risicomanagement onderwerp?",
    riskAssistantOnly:
      "Als risicomanagement assistent kan ik alleen helpen met risico-gerelateerde vragen.",
  },
  common: {
    type: "Type",
    cancel: "Annuleren",
    create: "Aanmaken",
    close: "Sluiten",
    name: "Naam",
    description: "Beschrijving",
    generalInformation: "Algemene Informatie",
    save: "Opslaan",
    delete: "Verwijderen",
    view: "Bekijken",
    edit: "Bewerken",
    back: "Ga terug",
    next: "Ga door",
    organisation: "Organisatie",
    organisations: "Organisaties",
    context: "Context",
    contexts: "Contexts",
    risk: "Risico",
    risks: "Risico's",
    consequence: "Gevolg",
    consequences: "Gevolgen",
    cause: "Oorzaak",
    causes: "Oorzaken",
    measure: "Maatregel",
    measures: "Maatregelen",
    user: "Gebruiker",
    users: "Gebruikers",
    branch: "Branch",
    branches: "Branches",
    branchArea: "Risicogebied",
    branchAreas: "Risicogebieden",
    actions: "Acties",
    yes: "Ja",
    no: "Nee",
    none: "Geen",
    subBracketOrganisation: "(Sub-)organisatie",
    confirmation: "Bevestigen",
    assessments: "Assessments",
    tags: "Tags",
    noTags: "Geen tags",
    confirm: "Bevestigen",
    chooseContext: "Kies een context",
    chooseBranchArea: "Kies een gebied",
    chooseStatus: "Kies een status",
    chooseCategory: "Kies een categorie",
    chooseValue: "Kies een waarde",
    min_value_placeholder: "Min waarde",
    max_value_placeholder: "Max waarde",
    expected_value_placeholder: "Verwachte waarde",
    measuresFor: "Beheersmaatregelen voor",
    financialDescription: "Financiële beschrijving",
    descriptionPlaceholder: "Beschrijving",
    warning: "Waarschuwing",
  },
  branch: {
    createTitle: "Branch aanmaken",
    editTitle: "Branch bewerken",
  },
  branchArea: {
    createTitle: "Risicogebied aanmaken",
    editTitle: "Risicogebied bewerken",
  },
  tags: {
    addTags: "Tags toevoegen...",
    enterTags: "Voer tags in (druk op Enter om toe te voegen)",
    suggestions: "Suggesties",
    noSuggestions: "Geen suggesties beschikbaar",
    tagsHelp: "Tags helpen bij het organiseren en filteren van items",
  },
  tag: {
    manageTags: "Tags beheren",
    add: "Tag toevoegen",
    edit: "Tag bewerken",
    delete: "Tag verwijderen",
    name: "Tagnaam",
    addTag: "Tag toevoegen",
    editTag: "Tag bewerken",
    noTags: "Geen tags gevonden",
    successCreate: "Tag succesvol aangemaakt",
    successUpdate: "Tag succesvol bijgewerkt",
    successDelete: "Tag succesvol verwijderd",
    errorSave: "Fout bij het opslaan van de tag",
    errorDelete: "Fout bij het verwijderen van de tag",
  },
  context: {
    type: {
      undefined: "-",
      null: "-",
      program: "Programma",
      goal: "Doel",
      process: "Proces",
      project: "Project",
      department: "Afdeling",
      asset: "Middel",
    },
    description: "Beschrijving",
    numberRisks: "Aantal Risico's",
    create: "Context Aanmaken",
    createTitle: "Context Aanmaken",
    super: "Bovenliggende Context",
    superNotAvailable: "N.v.t.",
    tags: "Context Tags",
  },
  risk: {
    risks: "Risico's",
    name: "Naam",
    description: "Omschrijving",
    context: "Context",
    probability: "Kans",
    status: "Status",
    riskStatus: {
      review: "Review",
      brainstorm: "Brainstorm",
      pending: "In afwachting",
      approved: "Geaccepteerd",
    },
    associatedContext: "Verbonden Context",
    netRisk: "Netto Risico",
    netConsequence: "Netto Gevolg",
    netFinancialConsequence: "Netto Financieel Gevolg",
    netProbability: "Netto Kans",
    grossRisk: "Bruto Risico",
    grossConsequence: "Bruto Gevolg",
    grossFinancialConsequence: "Bruto Financieel Gevolg",
    differenceConsequenceOverview: "Overzicht Verschillende Gevolgtypes",
    grossProbability: "Bruto Kans",
    create: "Risico toevoegen",
    timeValue: "Impact op Tijd",
    imageValue: "Impact op Imago",
    safetyValue: "Impact op Veiligheid",
    objectiveValue: "Impact op Doelstelling",
    environmentValue: "Impact op Milieu",
    timeConsequence: "Tijdgevolg",
    imageConsequence: "Imagogevolg",
    safetyConsequence: "Veiligheidsgevolg",
    financialMaxValue: "Maximale Financiële Impact",
    financialMinValue: "Minimale Financiële Impact",
    financialModeValue: "Verwachte Financiële Impact",
    financialConsequence: "Financieel Gevolg",
    objectiveConsequence: "Doelstellingsgevolg",
    environmentConsequence: "Milieu Gevolg",
    probabilityCovered: "Afgedekte Kans",
    category: "Categorie",
    tags: "Risico Tags",
    categoryOptions: {
      financial_economic: "Financieel / Economisch",
      legal_compliance: "Juridisch / Compliance",
      management_organisation: "Management / Organisatie",
      political_administrative: "Politiek / Bestuurlijk",
      quality_result: "Kwaliteit / Resultaat",
      safety_environment: "Veiligheid / Milieu",
      it_cyber: "IT / Cyber",
      geographic_environment: "Geografisch / Omgeving",
      technical: "Technisch",
      null: "n.v.t.",
    },
    editTitle: "Risico Bewerken",
    createTitle: "Risico Aanmaken",
    info: "Risico Informatie",
    analyse: "Risico Analyse",
    pieChartTitle: "Verdeling van oorzaken",
    saveRiskToAddCauses: "Sla het risico op om oorzaken toe te voegen.",
    addNewCause: "Voeg nieuwe oorzaak toe",
    saveSuccess: "Risico succesvol aangepast!",
    createSuccess: "Risico succesvol aangemaakt",
    deleteSuccess: "Risico succesvol verwijderd!",
    confirmDelete: "Weet je zeker dat je dit risico wilt verwijderen?",
    saveBeforeLeaving:
      "U heeft niet-opgeslagen wijzigingen. Wilt u deze opslaan voordat u verder gaat?",
    saveAndLeave: "Opslaan en verder",
    leaveWithoutSaving: "Verlaten zonder opslaan",
    saveRiskFirst: "Sla het risico eerst op voordat je een oorzaak toevoegt.",
  },
  consequence: {
    type: {
      undefined: "n.v.t.",
      null: "n.v.t.",
      financial: "Financieel",
      other: "Overig",
      image: "Imago",
      time: "Tijd",
      environment: "Milieu",
      safety: "Veiligheid",
      objective: "Doelstelling",
    },
    description: "Beschrijving",
    value: "Waarde",
    financial: "Financieel Gevolg",
    other: "Overige Gevolgen",
    financial_min_value: "Minimaal",
    financial_mode_value: "Verwacht",
    financial_max_value: "Maximaal",
  },
  cause: {
    causes: "Oorzaken",
    numberCauses: "Aantal oorzaken",
    createTitle: "Oorzaak aanmaken",
    editTitle: "Oorzaak bewerken",
    createdSuccessfully: "Oorzaak succesvol aangemaakt",
    updatedSuccessfully: "Oorzaak succesvol aangepast",
    deletedSuccessfully: "Oorzaak succesvol verwijderd",
    deleteConfirmation: "Weet je zeker dat je deze oorzaak wilt verwijderen?",
    confirmDeletion: "Bevestig verwijdering",
    name: "Naam",
    contribution: "Bijdrage",
    description: "Beschrijving",
    relatedCauses: "Neven-oorzaken",
    selectedRisk: "Geselecteerde Risico",
    pieCharts: "Verdelingsdiagrammen",
    create: "Oorzaak aanmaken",
    noneFoundForRisk: "Geen oorzaken gevonden voor dit risico",
  },
  measure: {
    measures: "Maatregelen",
    numberMeasures: "Aantal Maatregelen",
    createTitle: "Maatregel aanmaken",
    noRiskSelected:
      "Geen risico geselecteerd. Selecteer een risico om door te gaan.",
    selectRisk: "Selecteer een risico",
    editTitle: "Maatregel bewerken",
    createdSuccessfully: "Maatregel succesvol aangemaakt",
    updatedSuccessfully: "Maatregel succesvol aangepast",
    deletedSuccessfully: "Maatregel succesvol verwijderd",
    deleteConfirmation: "Weet je zeker dat je deze maatregel wilt verwijderen?",
    confirmDeletion: "Bevestig verwijdering",
    name: "Naam",
    contribution: "Bijdrage",
    description: "Beschrijving",
    attachToRisk: "Koppelen aan risico",
    attachToCause: "Koppelen aan oorzaak",
    relatedMeasures: "Maatregelen gekoppeld aan risico",
    relatedCauses: "Oorzaken gekoppeld aan risico",
    relatedMeasuresCauses: "Maatregelen gekoppeld aan geselecteerde oorzaak",
    selectedRisk: "Geselecteerde Risico",
    pieCharts: "Verdelingsdiagrammen",
    coverageSummary: "Dekkingssamenvatting",
    coverage: "Algemene Dekking",
    averageCoverage: "Gemiddelde Dekking",
    financialCoverage: "Financiële dekking",
    imageCoverage: "Imago-dekking",
    timeCoverage: "Tijddekking",
    environmentCoverage: "Milieudekking",
    safetyCoverage: "Veiligheidsdekking",
    objectiveCoverage: "Doelstellingsdekking",
    totalConsequenceCoverage: "Totale dekking",
    linkToThisCause: "Koppel aan deze oorzaak",
    useSpecificCoverage: "Gebruik specifieke maatregelen",
    useGeneralCoverage: "Gebruik algemene maatregelen",
    selectedCause: "Gekoppeld aan deze oorzaak",
    attachedRisk: "Gekoppeld risico",
    attachedCause: "Gekoppelde oorzaak",
    create: "Maatregel aanmaken",
    consequenceDescriptions: "Gevolg Omschrijvingen",
    coverageForRisk: "Dekking voor Risico",
    coverageForConsequences: "Dekking voor Gevolgen",
    coverageForCause: "Dekking voor Oorzaak",
    weightedAverageCauseCoverageExplanation:
      "Gewogen Gemiddelde Oorzaak Dekking Uitleg",
    numericExplanation: "Numerieke Uitleg",
    visualExplanation: "Visuele Uitleg",
    weightedAverageFormula:
      "Formule: (Som van Oorzaak Bijdrage * Oorzaak Dekking) / Totale Bijdrage",
    currentCalculation: "Huidige Berekening:",
    totalWeightedCoverage: "Totale Gewogen Dekking:",
    totalContribution: "Totale Bijdrage:",
    weightedAverage: "Gewogen Gemiddelde:",
    step1IndividualCauses: "Stap 1: Individuele Oorzaken en Gewogen Bijdrage",
    weightedContribution: "Gewogen Bijdrage",
    step2Summary: "Stap 2: Samenvatting van Totalen",
    step3FinalCalculation: "Stap 3: Eindberekening",
    totalSummary: "Totaal",
    pieChartVisualExplanation:
      "Deze grafiek visualiseert de proportie van elke oorzaak's bijdrage aan de totale gewogen dekking.",
    stripedCoverageExplanation:
      "De gestreepte gedeelten in de grafiek geven de dekkingsgraad van elke oorzaak aan. Een groter gestreept gebied betekent een hogere dekkingsgraad.",
    unsavedChangesWarning:
      "U heeft niet-opgeslagen wijzigingen. Wilt u deze opslaan voordat u verder gaat?",
    pageTitle: "Maatregelen voor: {riskName}",
    addNewMeasure: "Nieuwe maatregel toevoegen",
    status: "Status",
    selectStatus: "Selecteer status",
    statusEffective: "Effectief",
    statusNonEffective: "Niet Effectief",
    statusUnknown: "Onbekend",
  },
  user: {
    role: {
      super_admin: "Meta Beheerder",
      admin: "Beheerder",
      manager_extended: "Uitgebreide Manager",
      manager: "Manager",
      viewer: "Bekijker",
      viewer_extended: "Uitgebreide Bekijker",
      respondent: "Assessment Invuller",
    },
    firstName: "Voornaam",
    lastName: "Achternaam",
    username: "Gebruikersnaam",
    email: "Email Adres",
    roleField: "Functie",
    profile_picture: "Profiel Foto",
    changePassword: "Wachtwoord veranderen",
    oldPassword: "Oud Wachtwoord",
    newPassword: "Nieuw Wachtwoord",
    confirmPassword: "Wachtwoord bevestigen",
    editTitle: "Gebruiker Bewerken",
    password: "Wachtwoord",
    createTitle: "Gebruiker Aanmaken",
    jobTitle: "Functie Titel",
  },
  organisation: {
    name: "Naam",
    parentOrganisation: "Moeder Organisatie",
    manager: "Manager",
    additionalContactInfo: "Extra Contactinformatie",
    generalReserve: "Algemene Reserve",
    branch: "Branch",
    logo: "Logo",
    edit: {
      titleEdit: "Organisatie bewerken",
      titleCreate: "Organisatie aanmaken",
      generalInformation: "Algemene Informatie",
      successUpdate: "Organisatie succesvol aangepast!",
      successCreate: "Organisatie succesvol aangemaakt",
      successDelete: "Organisatie succesvol verwijderd!",
      confirmDelete: "Weet je zeker dat je de organisatie wilt verwijderen?",
      confirmDeleteTitle: "Bevestig verwijderen",
      selectOrganisation: "Selecteer een organisatie",
      selectManager: "Selecteer een manager",
      selectBranch: "Selecteer een afdeling",
      editRiskScales: "Risicoschalen Bewerken",
      combinedRiskScales: "Risicoschalen",
      scaleSuccessUpdate: "Risicoschaal succesvol bijgewerkt!",
    },
    create: "Organisatie Aanmaken",
    associated: "Verbonden organisatie",
    settings: {
      scale: {
        null: "-",
        undefined: "-",
        "n/a": "N.v.t.",
        n_a: "N.v.t.",
        very_small: "Zeer Klein",
        small: "Klein",
        medium: "Middel",
        large: "Groot",
        very_large: "Zeer Groot",
      },
    },
    scale: "Schaal",
    descriptionProbability: "Beschrijving Kans",
    descriptionConsequence: "Beschrijving Gevolg",
    referenceDescription: "Referentiekader",
    additionalConsequenceDescriptions: "Referentiekader per gevolgstype",
    additionalConsequenceExplanation:
      "Definieer hieronder de schaalomschrijvingen voor elk geselecteerd gevolgstype. Deze beschrijvingen worden gebruikt als referentie bij het bepalen van de impact van risico's.",
    probability: "Waarschijnlijkheid",
    probabilityMin: "Minimale Waarschijnlijkheid",
    financialMin: "Minimaal Financieel",
    probabilityScale: "Kans",
    financialScale: "Financiële Schaal",
    associatedManagers: "Verbonden Gebruikers",
    numberUsers: "Aantal Gebruikers",
    numberContexts: "Aantal Contexten",
  },
  save: "Opslaan",
  cancel: "Annuleren",
  delete: "Verwijderen",
  messages: {
    loadAssessmentDetailsFailed:
      "Het laden van de assessmentdetails is mislukt.",
    loadRecipientsFailed: "Het laden van de ontvangers is mislukt.",
    copiedTitle: "Gekopieerd",
    copiedToClipboard: "Token gekopieerd naar klembord!",
    copyFailed: "Kopiëren is mislukt.",
    assessmentLinkSubject: "Assessment Link",
    assessmentLinkBody: "Vul alstublieft uw assessment in:",
    loadingDetails: "Details worden geladen...",
    noAssessmentFound: "Geen assessment gevonden.",
    entryDeleted: "Inzending verwijderd",
    deleteEntryFailed: "Verwijderen van inzending mislukt",
    recipientDeleted: "Ontvanger verwijderd",
    deleteRecipientFailed: "Verwijderen van ontvanger mislukt",
    dataSubmittedSuccess: "Data successfully submitted.",
    errorSubmittingData: "Error submitting data.",
    failedToLoadAssessments: "Failed to load assessments.",
    loading: "Laden...",
    enterValidEmail: "Please enter a valid email address.",
    tagsUpdated: "Tags zijn bijgewerkt",
    errorUpdatingTags: "Fout bij het bijwerken van tags",
  },
  assessment: {
    create: "Assessment Aanmaken",
    completedTotal: "Aantal Compleet / Totaal",
    finish: "Assessment Afronden",
    sendAssessment: "Assessment Uitsturen",
    options: "Opties",
    useExistingValues: "Huidige risicowaardes meegeven",
    allRisks: "Alle Risico's",
    disabled: "Uitschakelen",
    active: "Actief",
    noEmailsProvided: "Geen emailaddressen opgegeven",
    enterEmailAddress: "Enter email address",
    addEmail: "Add Email",
    actions: "Acties",
    delete: "Delete",
  },
  analyse: {
    simulate: "Simuleren",
  },
  assessmentDetail: {
    header: "Assessment",
    steps: {
      grouping: "Groeperen",
      distributing: "Verdelen",
      overview: "Overzicht",
    },
    confirmSending: "Bevestig Verzending",
    dialogInstruction:
      "Elk assessment onderdeel wordt naar de volgende email-addressen gestuurd.",
    noEmails: "Geen e-mailadressen",
    confirmAndSend: "Bevestigen en Verzenden",
    information: "Informatie",
    organisationName: "Organisatie",
    assessmentStatus: "Status",
    status: {
      draft: "Concept",
      sent: "Uitgestuurd",
      partiallyCompleted: "Deels Afgerond",
      partially_completed: "Deels Afgerond",
      completed: "Afgerond",
    },
    splittingMethod: "Verdelingsmethode",
    splittingMethodOptions: {
      branch_area: "Op Risicogebied",
      context: "Op Context",
      organisation: "Op Organisatie",
      undefined: "Niet",
      null: "Niet",
      "": "Niet",
    },
    notAvailable: "N/B",
    totalPeople: "Totaal aantal personen",
    completedPeople: "Aantal voltooid",
    totalRisks: "Totaal aantal risico's",
    risks: "Risico's",
    riskDetailedInfo: "Risico Gedetailleerde Informatie",
    branchArea: "Risicogebied",
    financialMax: "Max. Financieel Gevolg",
    entries: "Inzendingen",
    participantEmail: "Deelnemer E-mail",
    unknown: "Onbekend",
    probability: "Kans",
    comment: "Opmerking",
    count_done: "Aantal afgevinkt / Totaal",
    assignedTo: "Toegewezen op",
    riskId: "ID",
    suggestedNamePlaceholder: "Voorgestelde Naam",
    suggestedDescriptionPlaceholder: "Voorgestelde Omschrijving",
    selectProbability: "Selecteer Kans",
    selectValue: "Selecteer Waarde",
    recipients: "Ontvangers",
    email: "E-mailadres",
    submitted: "Ingediend?",
    authToken: "Auth Token",
    copyToken: "Kopieer Token",
    copyLink: "Kopieer Link",
    sendMail: "Verstuur Mail",
    signOffProgress: "Afvinkvoortgang",
    signOffRisk: "✔",
    undoSignOffRisk: "✘",
    completedStripe: "Klaar?",
    completeAssessmentBtn: "Beoordeling voltooien",
    confirmCompleteTitle: "Beoordeling voltooien?",
    warning: "Waarschuwing",
    confirmNotAllPeople:
      "Er zijn nog {count} personen die niet hebben ingediend. Weet je zeker dat je wilt doorgaan?",
    confirmNotAllRisksSignedOff:
      "Er zijn nog {count} risico('s) niet afgevinkt. Weet je zeker dat je wilt doorgaan?",
    confirmCompletion: "Weet je zeker dat je de beoordeling wilt voltooien?",
    completionCancelled: "Voltooien geannuleerd.",
    confirmDeleteEntry: "Weet je zeker dat je deze inzending wilt verwijderen?",
    confirmDeleteRecipient:
      "Weet je zeker dat je deze ontvanger wilt verwijderen?",
  },
  scale: {
    "n/a": "N.v.t.",
    n_a: "N.v.t.",
    very_small: "Zeer Klein",
    small: "Klein",
    medium: "Middel",
    large: "Groot",
    very_large: "Zeer Groot",
    null: "-",
    undefined: "-",
  },
  validation: {
    fieldRequired: "Veld is verplicht",
    nameRequired: "Naam is verplicht",
    managerRequired: "Manager is verplicht",
    contextTypeRequired: "Type is verplicht",
    organisationRequired: "Organisatie is verplicht",
    branchRequired: "Afdeling is verplicht",
    generalReserveRequired: "Algemene reserve is verplicht",
    contextRequired: "Context is verplicht",
    branchAreaRequired: "Risicogebied is verplicht",
    riskStatusRequired: "Status is verplicht",
    probabilityRequired: "Kans is verplicht",
    financialMinRequired: "Minimale financiële waarde is verplicht",
    financialMaxRequired: "Maximale financiële waarde is verplicht",
    riskRequired: "Koppel een risico aan deze oorzaak",
    contributionRequired: "Bijdrage is verplicht",
    riskOrCauseRequired: "Koppel de maatregel aan een risico of oorzaak",
    coverageRequired: "Dekkingspercentage is verplicht bij algemene dekking",
    specificCoverageRequired:
      "Dekkingspercentage is verplicht bij alle specifieke dekkingen",
    statusRequired: "Status is verplicht",
    correctErrorsBeforeSave:
      "Niet alle verplichte velden zijn correct ingevuld. Controleer de gemarkeerde rijen.",
    passwordMismatch: "Wachtwoorden komen niet overeen.",
    roleRequired: "Rol is verplicht",
    emailRequired: "Email is verplicht",
    emailFormat: "Dit is geen juist email adres",
    usernameRequired: "Gebruikersnaam is verplicht",
    firstNameRequired: "Voornaam is verplicht",
    lastNameRequired: "Achternaam is verplicht",
    passwordRequired: "Wachtwoord is verplicht",
    generalReserveShouldBeEmptyWhenParent:
      "Algemene reserve moet leeg, wanneer moeder organisatie is gezet.",
    branchShouldBeEmptyWhenParent:
      "Branch moet leeg, wanneer moeder organisatie is gezet.",
    fillRequiredFields: "Vul alle verplichte velden in.",
    tagNameRequired: "Tagnaam is verplicht",
    validationFailed: "Validatie mislukt. Controleer de ingevoerde gegevens.",
  },
  undefined: "",
  null: "",
  true: "Ja",
  false: "Nee",
} as const;

export default nl;
